import { render, staticRenderFns } from "./HeaderStats.vue?vue&type=template&id=1faea9df&"
import script from "./HeaderStats.vue?vue&type=script&lang=js&"
export * from "./HeaderStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports